import { render, staticRenderFns } from "./addEditViewDialog.vue?vue&type=template&id=bb87eff8&scoped=true"
import script from "./addEditViewDialog.vue?vue&type=script&lang=js"
export * from "./addEditViewDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditViewDialog.vue?vue&type=style&index=0&id=bb87eff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb87eff8",
  null
  
)

export default component.exports